import API, { DATA_API } from 'helpers/api'
import { Grade } from './grade'

export async function getStaffListGoodImpression({
  accountIds,
  filters,
  signal,
}: getStaffListGoodImpressionInput) {
  if (!accountIds.length) {
    return { summary: {}, records: [] } as never as Response
  }

  const data = {
    accountIds,
    filters,
  }

  const source = API.getCancelToken().source()

  const promise = API.get<Response>({
    api: DATA_API,
    url: '/calls/metrics/staff-good-impression',
    params: data,
    cancelToken: source.token,
  })

  // Cancel the request if TanStack Query signals to abort
  signal?.addEventListener('abort', () => {
    source.cancel('Query was cancelled by TanStack Query')
  })

  return promise
}

export type getStaffListGoodImpressionInput = {
  accountIds: string[]
  filters: {}
  signal?: AbortSignal
}

export type Response = {
  summary: {
    total: number
    goodImpression: number
    goodImpressionPercentage: number
    goodImpressionGrade: Grade
  }
  records: Array<{
    callHandlerId: string
    callHandlerName: string
    total: number
    goodImpressionTotal: number
    goodImpressionPercentage: number
    goodImpressionGrade: Grade
  }>
}
